/**
 * The only layout in this app: a centred page body, no chrome.
 *
 * Every screen here renders inside the CRM custom-page iframe, which
 * already supplies the surrounding navigation — a top bar of our own would just
 * duplicate it and eat vertical space.
 */
// The body grows with the screen: a fixed 72rem left wide monitors with half
// the screen as empty margin. It still stops short of edge-to-edge, so lines
// of text and rows of cards stay readable.
const BlankLayout = ({ children }) => (
  <div className="min-h-screen bg-ink-50">
    <main className="mx-auto w-full max-w-6xl px-5 py-8 sm:px-8 xl:max-w-7xl 2xl:max-w-[100rem] 2xl:px-10">
      {children}
    </main>
  </div>
);

export default BlankLayout;
